import * as React from "react";
import * as _ from "lodash";
import { connect, Dispatch } from "react-redux";
import {
    IApplicationState, AppActionCreators,
    IRccapState, RccapActionCreators, IRccapLookupDataResponse, IRccapResponse, ILookupData,
    IRccapPositionDetailResponse,
    SwapActionCreators
} from "@nkr/store/index";
import { Row, Col, Panel, FormGroup, ControlLabel, Alert, Badge } from "react-bootstrap";
import ViewAdditionalQuestions from "./rccap-additional-questions";

interface IProps {
    id: number,
    centerId: number
}

interface IStateProps {
    rccap: IRccapState
}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getLookupData: () => Promise<IRccapLookupDataResponse>,
    // setLookupData: (lookupData: ILookupData) => void,
    getRccap: (id: number) => Promise<IRccapResponse>,
    getRccapDetails: (chainId: number, clusterNumber: number, positionNumber: number) => Promise<IRccapPositionDetailResponse>
}

type TProps =
    IProps
    & IStateProps
    & IDispatchProps;

class RccapView extends React.Component<TProps, {}> {
    componentDidMount = () => {
        this.getData();
    }

    private getData = () => {
        let id = this.props.id;

        this.props.showLoading("Getting RCCAP info, one moment please...").then(() => {
            Promise.all([
                this.props.getRccap(id),
                this.props.getLookupData()
            ])
                .then(() => {
                    this.props.hideLoading();
                });
        });
    }

    render = () => {
        if (this.props.rccap.info == null)
            return null;

        const satisfactoryResponse = this.props.rccap.info.satisfactoryResponse > 0 ? this.props.rccap.lookupData.satisfactoryResponses.find(x => x.id == this.props.rccap.info.satisfactoryResponse) : null;
        const satisfactoryResponseDescription = satisfactoryResponse ? satisfactoryResponse.description : '[Not Specified]';

        return (
            <div className="container" style={{ paddingBottom: 20 }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", height: 30, marginTop: 30, marginBottom: 40 }}>
                    <div style={{ fontSize: 28, fontWeight: 500 }}>
                        VIEW RCCAP
                    </div>
                    <div>
                        <a href={`/center/${this.props.centerId}/reports/my-center/rccap?status=0&fail_date=12`} className="btn btn-link">Return to the RCCAP List</a>
                    </div>
                </div>

                <Panel>
                    <Panel.Heading>Swap Details</Panel.Heading>
                    <Panel.Body>
                        <Row>
                            <Col xs={6} lg={6}>
                                <FormGroup>
                                    <ControlLabel>Swap</ControlLabel>
                                    <div>{this.props.rccap.info.swapChainNumber} / {this.props.rccap.info.swapClusterNumber} / {this.props.rccap.info.swapPositionNumber}</div>
                                </FormGroup>
                            </Col>
                            <Col xs={6} lg={6}>
                                <FormGroup>
                                    <ControlLabel>Responsible Center</ControlLabel>
                                    <div>{this.props.rccap.info.responsibleCenterAlias}</div>
                                </FormGroup>
                            </Col>
                        </Row>


                        <Row>
                            <Col xs={6} lg={6}>
                                <div>
                                    <FormGroup>
                                        <ControlLabel>RCCAP Requester</ControlLabel>
                                        <div>{this.props.rccap.info.rccapRequester}</div>
                                    </FormGroup>
                                </div>

                                <div>
                                    <FormGroup>
                                        <ControlLabel>NKR Liaison</ControlLabel>
                                        <div>{this.props.rccap.info.rccapManagerId == 7 ? 'Julia Kononenko' : this.props.rccap.info.rccapManager}</div>
                                    </FormGroup>
                                </div>
                            </Col>
                            <Col xs={6} lg={6}>
                                <div>
                                    <FormGroup>
                                        <ControlLabel>Date Swap Failed</ControlLabel>
                                        <div>{this.props.rccap.info.failDate}</div>
                                    </FormGroup>
                                </div>

                                <div>
                                    <FormGroup>
                                        <ControlLabel>Target Surgery Date</ControlLabel>
                                        <div>{this.props.rccap.info.targetSurgeryDate}</div>
                                    </FormGroup>
                                </div>

                                <div>
                                    <FormGroup>
                                        <ControlLabel>Response Deadline</ControlLabel>
                                        <div>{this.props.rccap.info.dueDate}</div>
                                    </FormGroup>
                                </div>
                            </Col>
                        </Row>
                    </Panel.Body>
                </Panel>

                <Panel>
                    <Panel.Heading>Position Details</Panel.Heading>
                    <Panel.Body>
                        <Row>
                            <Col xs={6} lg={6}>
                                <div>
                                    <FormGroup>
                                        <ControlLabel>Donor Center</ControlLabel>
                                        <div>{this.props.rccap.info.donorCenterAlias}</div>
                                    </FormGroup>
                                </div>

                                <div>
                                    <FormGroup>
                                        <ControlLabel>Donor Alias</ControlLabel>
                                        <div>{this.props.rccap.info.donorAlias}</div>
                                    </FormGroup>
                                </div>

                                <div>
                                    <FormGroup>
                                        <ControlLabel>Transplants Impacted</ControlLabel>
                                        <div>{this.props.rccap.info.transplantsImpacted}</div>
                                    </FormGroup>
                                </div>

                                <div>
                                    <FormGroup>
                                        <ControlLabel>Date Match Offered</ControlLabel>
                                        <div>{this.props.rccap.info.matchOfferDate}</div>
                                    </FormGroup>
                                </div>

                                <div>
                                    <FormGroup>
                                        <ControlLabel>Date EXM Requested</ControlLabel>
                                        <div>{this.props.rccap.info.exmRequestDate ? this.props.rccap.info.exmRequestDate : '[Not Specified]'}</div>
                                    </FormGroup>
                                </div>

                                <div>
                                    <FormGroup>
                                        <ControlLabel>Phase</ControlLabel>
                                        <div>{this.props.rccap.info.phaseDescription}</div>
                                    </FormGroup>
                                </div>
                            </Col>
                            <Col xs={6} lg={6}>
                                <div>
                                    <FormGroup>
                                        <ControlLabel>Recipient Center</ControlLabel>
                                        <div>{this.props.rccap.info.recipientCenterAlias}</div>
                                    </FormGroup>
                                </div>

                                <div>
                                    <FormGroup>
                                        <ControlLabel>Recipient Alias</ControlLabel>
                                        <div>{this.props.rccap.info.recipientAlias}</div>
                                    </FormGroup>
                                </div>

                                <div>
                                    <FormGroup>
                                        <ControlLabel>Recipient ABO</ControlLabel>
                                        <div>{this.props.rccap.info.recipientAbo}</div>
                                    </FormGroup>
                                </div>

                                <div>
                                    <FormGroup>
                                        <ControlLabel>Paired Donor ABO</ControlLabel>
                                        <div>{this.props.rccap.info.recipientsDonorAbo ? this.props.rccap.info.recipientsDonorAbo : '[No Donor Found]'}</div>
                                    </FormGroup>
                                </div>

                                <div>
                                    <FormGroup>
                                        <ControlLabel>PMPc</ControlLabel>
                                        <div>{this.props.rccap.info.recipientPmpc}</div>
                                    </FormGroup>
                                </div>

                                <div>
                                    <FormGroup>
                                        <ControlLabel>NKR cPRA</ControlLabel>
                                        <div>{this.props.rccap.info.recipientCpra}</div>
                                    </FormGroup>
                                </div>
                            </Col>
                        </Row>
                    </Panel.Body>
                </Panel>

                <Row>
                    <Col xs={12} lg={12}>
                        <Panel>
                            <Panel.Heading><b>What Happened?</b></Panel.Heading>
                            <Panel.Body>
                                {this.props.rccap.info.whatHappened ? this.props.rccap.info.whatHappened : '[Not Specified]'}
                            </Panel.Body>
                        </Panel>
                    </Col>
                </Row>

                <Row>
                    <Col xs={12} lg={12}>
                        <Panel>
                            <Panel.Heading><b>Additional Questions for the Responsible Center</b></Panel.Heading>
                            <Panel.Body>
                                {this.props.rccap.info.originalAdditionalQuestions ?
                                    <Alert style={{ padding: "5px 7.5px", marginBottom: 0 }}>
                                        <h4>Original Questions</h4>
                                        <p>{this.props.rccap.info.originalAdditionalQuestions.split('\n').map((question, index) =>
                                            <div key={index}>{question}</div>
                                        )}</p>
                                    </Alert>
                                    :
                                    <ViewAdditionalQuestions
                                        additionalQuestions={this.props.rccap.info.additionalQuestions}
                                    />
                                }
                            </Panel.Body>
                            {this.props.rccap.info.originalAdditionalQuestions && (
                                <Panel.Footer>
                                    Previously, the additional questions were just freeform text, but going forward each question/answer combination will be saved individually.<br />
                                    The <Badge style={{ color: '#31708f', backgroundColor: '#d9edf7', borderColor: '#bce8f1' }}>Original Questions</Badge> above are presented as entered.
                                </Panel.Footer>
                            )}
                        </Panel>
                    </Col>
                </Row>

                <Row>
                    <Col xs={12} lg={12}>
                        <Panel>
                            <Panel.Heading><b>Root Cause Classification</b></Panel.Heading>
                            <Panel.Body>
                                <Row>
                                    <Col xs={6} lg={6}>
                                        <div>
                                            <FormGroup>
                                                <ControlLabel>Primary</ControlLabel>
                                                <div>{this.props.rccap.info.rootCausePrimary}</div>
                                            </FormGroup>
                                        </div>

                                        <div>
                                            <FormGroup>
                                                <ControlLabel>Secondary</ControlLabel>
                                                <div>{this.props.rccap.info.rootCauseSecondary}</div>
                                            </FormGroup>
                                        </div>
                                    </Col>
                                    <Col xs={6} lg={6}>
                                        <div>
                                            <FormGroup>
                                                <ControlLabel>Avoidable</ControlLabel>
                                                <div>{this.props.rccap.info.avoidableDescription}</div>
                                            </FormGroup>
                                        </div>

                                        <div>
                                            <FormGroup>
                                                <ControlLabel>If Avoidable, Billable?</ControlLabel>
                                                <div>{this.props.rccap.info.billableDescription}</div>
                                            </FormGroup>
                                        </div>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col xs={12} lg={12}>
                                        <div>
                                            <FormGroup>
                                                <ControlLabel>Satisfactory Response</ControlLabel>
                                                <div>{satisfactoryResponseDescription}</div>
                                            </FormGroup>
                                        </div>

                                        <div>
                                            <FormGroup>
                                                <ControlLabel>Accepted Response</ControlLabel>
                                                <div>{this.props.rccap.info.rootCauseInfo ? this.props.rccap.info.rootCauseInfo : '[Not Specified]'}</div>
                                            </FormGroup>
                                        </div>
                                    </Col>
                                </Row>
                            </Panel.Body>
                        </Panel>
                    </Col>
                </Row>

                <Row>
                    <Col xs={12} lg={12}>
                        <Panel>
                            <Panel.Heading><b>Corrective Action Plan</b></Panel.Heading>
                            <Panel.Body>
                                <Row style={{ marginBottom: 0 }}>
                                    <Col xs={12} lg={12}>
                                        <div>
                                            <FormGroup>
                                                <ControlLabel>Primary</ControlLabel>
                                                <div>{this.props.rccap.info.correctiveActionPrimaryDescription}</div>
                                            </FormGroup>
                                        </div>

                                        <div>
                                            <FormGroup>
                                                <ControlLabel>Secondary</ControlLabel>
                                                <div>{this.props.rccap.info.correctiveActionSecondaryDescription}</div>
                                            </FormGroup>
                                        </div>

                                        <div>
                                            <FormGroup>
                                                <ControlLabel>Additional Corrective Action Information</ControlLabel>
                                                <div>{this.props.rccap.info.correctiveActionInfo ? this.props.rccap.info.correctiveActionInfo : '[Not Specified]'}</div>
                                            </FormGroup>
                                        </div>
                                    </Col>
                                </Row>
                            </Panel.Body>
                        </Panel>
                    </Col>
                </Row>

                <Row>
                    <Col xs={12} lg={12}>
                        <Panel>
                            <Panel.Heading><b>RCCAP Response</b></Panel.Heading>
                            <Panel.Body>
                                <Row>
                                    <Col xs={6} lg={6}>
                                        <FormGroup>
                                            <ControlLabel>Center Responder</ControlLabel>
                                            <div>{this.props.rccap.info.responder}</div>
                                        </FormGroup>
                                    </Col>

                                    <Col xs={6} lg={6}>
                                        <FormGroup>
                                            <ControlLabel>Response Date</ControlLabel>
                                            <div>{this.props.rccap.info.responseDate}</div>
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </Panel.Body>
                        </Panel>
                    </Col>
                </Row>

                <Row>
                    <Col style={{ display: "flex", justifyContent: "center" }}>
                        <a href={`/center/${this.props.centerId}/reports/my-center/rccap?status=0&fail_date=12`} className="btn btn-link">Return to the RCCAP List</a>
                    </Col>
                </Row>
            </div>
        );
    }
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {
        rccap: appState.rccap
    };
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => { return dispatch(AppActionCreators.showLoadingAsync(message)); },
        hideLoading: () => { dispatch(AppActionCreators.hideLoading()); },
        getLookupData: () => { return dispatch(RccapActionCreators.getRccapLookupData(false)); },
        // setLookupData: (lookupData) => { dispatch(RccapActionCreators.setRccapLookupData(lookupData)); },
        getRccap: (id) => { return dispatch(RccapActionCreators.getRccap(id, true)); },
        getRccapDetails: (chainId, clusterNumber, positionNumber) => { return dispatch(SwapActionCreators.getRccapDetails(chainId, clusterNumber, positionNumber)); }
    };
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(RccapView);